@if (data === undefined || (data === false && !Array.isArray(data))) {
  <div [ngClass]="{ positioned: positioned }">
    <!-- [ngStyle]="{width: size ? size : 'auto', height: size || 'auto'}"> -->
    <mat-progress-spinner class="m-auto" color="primary" mode="indeterminate" [diameter]="size" aria-label="Loading..."></mat-progress-spinner>
  </div>
}
